var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name == 'billing_dashboard')?_c('DashboardNavbar'):_vm._e(),(
            _vm.$route.name == 'invoice' ||
            _vm.$route.name == 'direct-url-billing-invoice-profile'
        )?_c('InvoicePageNavbar'):_vm._e(),(
            _vm.$route.name == 'estimate' ||
            _vm.$route.name == 'direct-url-billing-estimate-profile'
        )?_c('EstimatePageNavbar'):_vm._e(),(_vm.$route.name == 'return')?_c('ReturnPageNavbar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }